import React from 'react';
import { CalculatorSchema } from './CalculatorSchema';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

const CalculatorData = (props) => {
    const { block, data, onChangeBlock } = props;
    const schema = CalculatorSchema({ ...props });

    return (
        <BlockDataForm
            schema={schema}
            title={schema.title}
            onChangeField={(id, value) => {
                onChangeBlock(block, {
                    ...data,
                    [id]: value,
                });
            }}
            formData={data}
            block={block}
        />
    );
};
export default CalculatorData;